export default __webpack_public_path__ + "static/media/eKYC_Result_Fail@2x.f2e3d783.png";